export const head = [
  {
    id: 0,
    title: "RANKING",
  },
  {
    id: 1,
    title: "NAME",
  },
  {
    id: 2,
    title: "RECORD",
  },
];
